import { Controller } from "@hotwired/stimulus";

// Applies a subtle parallax scroll effect to child elements.
// Each target moves at a different rate based on its data-parallax-speed attribute.
// Uses IntersectionObserver to only animate when visible.
export default class extends Controller {
  static targets = ["layer"];
  static values = {
    center: { type: Number, default: 0.5 },
    multiplier: { type: Number, default: 200 },
  };

  connect() {
    this.ticking = false;
    this.isVisible = true;

    this.observer = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
      },
      { threshold: 0 },
    );
    this.observer.observe(this.element);

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll);
    this.observer?.disconnect();
  }

  onScroll() {
    if (!this.isVisible || this.ticking) return;

    this.ticking = true;
    requestAnimationFrame(() => {
      this.updatePositions();
      this.ticking = false;
    });
  }

  updatePositions() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    // 0 when element top enters viewport bottom, 1 when it reaches the top
    const progress = 1 - rect.top / windowHeight;

    this.layerTargets.forEach((layer) => {
      const speed = parseFloat(layer.dataset.parallaxSpeed) || 0;
      const offset =
        (this.centerValue - progress) * speed * this.multiplierValue;
      layer.style.transform = `translateY(${offset}px)`;
    });
  }
}
